import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-points-sample',
  templateUrl: './points-sample.component.html',
  styleUrls: ['./points-sample.component.scss']
})
export class PointsSampleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
